// https://codepen.io/emmawedekind/pen/eXNppG?editors=1010
import {faChevronDown, faChevronUp} from '@fortawesome/pro-solid-svg-icons';
import {useState} from 'react';
import styled from 'styled-components';

import {
  SelectContainer,
  FieldMargin,
} from '../../_old/FieldHelpers/FieldContainers';
import {Icon} from '../../components/Icon/Icon';
import {scToTwColour} from '../../theme';

import {OptionsList} from './OptionsList';

const SPACEBAR_KEY_CODES = [0, 32];

type Props = React.HTMLAttributes<HTMLDivElement> & {
  collection: [string, string][];
  value: string;
  select: (v: string) => void;
  toggle?: () => void;
  children?: React.ReactNode;
  error?: {
    message: string;
    component: React.ReactNode;
  };
  required?: boolean;
  readOnly?: boolean;
  className?: string;
};
export function Select(props: Props): React.JSX.Element {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggle = (): void => {
    if (props.readOnly) {
      return;
    }

    props.toggle && props.toggle();
    setIsExpanded((_isExpanded) => !_isExpanded);
  };

  const close = (): void => setIsExpanded(false);
  const selected = props.collection.find((option) => option[0] === props.value);

  return (
    <FieldMargin className={props.className} >
      {props.children && (
        <Label className="small-upper" required={!!props.required}>
          {props.children}
        </Label>
      )}

      <SelectContainer
        isActive={isExpanded}
        error={props.error?.message}
        readOnly={props.readOnly}
        role="button"
        tabIndex={0}
        onClick={toggle}
        onKeyUp={(e) => SPACEBAR_KEY_CODES.includes(e.keyCode) && toggle()}
        onBlur={close}
      >
        <span>
          {selected ? selected[1] : <GreyText>Select an option</GreyText>}
        </span>

        {!props.readOnly && (
          <StyledIcon
            icon={isExpanded ? faChevronUp : faChevronDown}
            className="text-slate11"
          />
        )}

        {isExpanded && (
          <OptionsList
            collection={props.collection}
            select={props.select}
            close={close}
            aria-expanded={isExpanded}
          />
        )}
      </SelectContainer>

      {props.error && props.error.component}
    </FieldMargin>
  );
}

const GreyText = styled.span`
  color: ${scToTwColour('theme.colors.slate11')};
`;
const Label = styled.label<{required: boolean}>`
  position: relative;
`;
const StyledIcon = styled(Icon)`
  margin-left: 0.5em;
`;
